module.exports = __webpack_public_path__ + "711999f4180ae9c579917c6a912166ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index_20.png
// module id = 253
// module chunks = 1